import "./LoadingSpinner.scss";

/**
 * A loading spinner which is only used for the initial loading of the SPA.
 */
const LoadingSpinner = function () {
  return (
    <div className="d-flex w-100 h-100 justify-content-center align-items-center">
      <div className="lds-roller">
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
};

export default LoadingSpinner;
